// MachineUtilizationDashboard/components/UtilizationRankingChart.jsx

import Chart from "react-apexcharts";
import { formatNumber } from "../utils/machineDashboardUtils";

function UtilizationRankingChart({ topMachines = [], bottomMachines = [] }) {
  const topData = Array.isArray(topMachines) ? topMachines.slice(0, 10) : [];
  const bottomData = Array.isArray(bottomMachines)
    ? bottomMachines.slice(0, 10)
    : [];

  const buildOptions = (machines, type) => ({
    chart: {
      type: "bar",
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      parentHeightOffset: 0,
    },

    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 6,
        borderRadiusApplication: "end",
        barHeight: "58%",
      },
    },

    colors: [type === "top" ? "#053c83" : "#ef4444"],

    dataLabels: {
      enabled: true,

      formatter: (value) => `${formatNumber(value, 1)}%`,

      style: {
        fontSize: "10px",
        fontWeight: 700,
      },
    },

    xaxis: {
      categories: machines.map(
        (item) => item?.machineCode || item?.machineName || "-",
      ),

      labels: {
        formatter: (value) => `${formatNumber(value)}%`,

        style: {
          colors: "#64748b",
          fontSize: "10px",
        },
      },
    },

    yaxis: {
      labels: {
        minWidth: 60,
        maxWidth: 180,

        style: {
          colors: "#334155",
          fontSize: "12px",
          fontWeight: 600,
        },
      },
    },

    grid: {
      borderColor: "#edf2f7",
      strokeDashArray: 4,

      padding: {
        left: 4,
        right: 12,
      },
    },

    tooltip: {
      custom: ({ dataPointIndex }) => {
        const machine = machines[dataPointIndex];

        if (!machine) return "";

        return `
        <div class="mud-chart-tooltip">
          <strong>${machine.machineCode || "-"}</strong>
          <span>${machine.machineName || "-"}</span>
          <span>${machine.deptName || "-"}</span>
          <b>${formatNumber(machine.utilizationPercentage, 2)}%</b>
        </div>
      `;
      },
    },
  });

  return (
    <div className="mud-ranking-grid">
      <div className="mud-ranking-chart">
        <div className="mud-ranking-chart__title">
          <span className="mud-ranking-icon mud-ranking-icon--top">
            <i className="bi bi-trophy-fill" />
          </span>

          <div>
            <h4>Top 10 Utilized Machines</h4>
            <p>Highest utilization across eligible machines</p>
          </div>
        </div>

        {topData.length > 0 ? (
          <Chart
            key={`top-${topData.map((item) => item.machineCode).join("-")}`}
            options={buildOptions(topData, "top")}
            series={[
              {
                name: "Utilization",
                data: topData.map((item) =>
                  Number(item?.utilizationPercentage || 0),
                ),
              },
            ]}
            type="bar"
            height={380}
          />
        ) : (
          <div className="mud-empty-state">No utilization data available.</div>
        )}
      </div>

      <div className="mud-ranking-chart">
        <div className="mud-ranking-chart__title">
          <span className="mud-ranking-icon mud-ranking-icon--bottom">
            <i className="bi bi-graph-down-arrow" />
          </span>

          <div>
            <h4>Bottom 10 Underutilized</h4>
            <p>Machines requiring closer performance review</p>
          </div>
        </div>

        {bottomData.length > 0 ? (
          <Chart
            key={`bottom-${bottomData
              .map((item) => item.machineCode)
              .join("-")}`}
            options={buildOptions(bottomData, "bottom")}
            series={[
              {
                name: "Utilization",
                data: bottomData.map((item) =>
                  Number(item?.utilizationPercentage || 0),
                ),
              },
            ]}
            type="bar"
            height={380}
          />
        ) : (
          <div className="mud-empty-state">No utilization data available.</div>
        )}
      </div>
    </div>
  );
}

export default UtilizationRankingChart;
